import {
  GET_SHOP_CATEGORY_ICONS_START,
  GET_SHOP_CATEGORY_ICONS_SUCCESS,
  GET_SHOP_CATEGORY_ICONS_ERROR,
  ADD_SHOP_CATEGORY_ICON_START,
  ADD_SHOP_CATEGORY_ICON_SUCCESS,
  ADD_SHOP_CATEGORY_ICON_ERROR,
  EDIT_SHOP_CATEGORY_ICON_START,
  EDIT_SHOP_CATEGORY_ICON_SUCCESS,
  EDIT_SHOP_CATEGORY_ICON_ERROR,
  DELETE_SHOP_CATEGORY_ICON_START,
  DELETE_SHOP_CATEGORY_ICON_SUCCESS,
  DELETE_SHOP_CATEGORY_ICON_ERROR
} from '../constants';

const initialState = {
  placements: [],
  loading: false,
  error: null
};

export default function adminShopCategoryIcons(state = initialState, action) {
  switch (action.type) {
    case GET_SHOP_CATEGORY_ICONS_START:
    case ADD_SHOP_CATEGORY_ICON_START:
    case EDIT_SHOP_CATEGORY_ICON_START:
    case DELETE_SHOP_CATEGORY_ICON_START:
      return { ...state, loading: true, error: null };
    case GET_SHOP_CATEGORY_ICONS_SUCCESS:
      return { ...state, placements: action.payload, loading: false, error: null };
    case ADD_SHOP_CATEGORY_ICON_SUCCESS:
    case EDIT_SHOP_CATEGORY_ICON_SUCCESS:
    case DELETE_SHOP_CATEGORY_ICON_SUCCESS:
      return { ...state, loading: false, error: null };
    case GET_SHOP_CATEGORY_ICONS_ERROR:
    case ADD_SHOP_CATEGORY_ICON_ERROR:
    case EDIT_SHOP_CATEGORY_ICON_ERROR:
    case DELETE_SHOP_CATEGORY_ICON_ERROR:
      return { ...state, loading: false, error: action.error || 'Something went wrong' };
    default:
      return state;
  }
} 